import { useTranslation } from 'react-i18next';
import { Button } from '@chakra-ui/react';

import { useTracking } from '@izimi/components';
import { TrackingEventAction, TrackingEventCategory } from '@izimi/modules';
import { useLogout } from 'core/hooks/useLogout';

export const ButtonLogout = () => {
  const { t } = useTranslation('shared');
  const { trackEvent } = useTracking();
  const logout = useLogout();

  const onLogout = () => {
    trackEvent({
      category: TrackingEventCategory.General,
      action: TrackingEventAction.LogoutButtonClicked,
    });
    logout();
  };

  return (
    <Button variant='secondary400' onClick={onLogout} height='45px'>
      {t('navigation.logout')}
    </Button>
  );
};
